/* eslint-disable react-hooks/exhaustive-deps */
import {CommunicationProvider} from "context/CommunicationContext"
import {ChatRoomProvider} from "context/ChatRoomContext"
import {StudentChat} from "../StudentChat"

type Props = {
    user: any
    userIdField: string
    departmentId: number
}

const StudentChatTabView = (props: Props) => {
    const {departmentId, user, userIdField} = props
    return <StudentChat user={user} userIdField={userIdField} departmentId={departmentId} />
}

export function StudentChatTab(props: Props) {
    return (
        <CommunicationProvider>
            <ChatRoomProvider>
                <StudentChatTabView {...props} />
            </ChatRoomProvider>
        </CommunicationProvider>
    )
}
